//      
import getClosestScrollable from './get-closest-scrollable';

                    
                              
                         
   

// TODO: do this check at the same time as the closest scrollable
// in order to avoid double calling getComputedStyle
// Do this when we move to multiple scroll containers
const getIsFixed = (el          )          => {
  if (!el) {
    return false;
  }
  const style                      = window.getComputedStyle(el);
  if (style.position === 'fixed') {
    return true;
  }
  return getIsFixed(el.parentElement);
};

export default (start         )      => {
  const closestScrollable           = getClosestScrollable(start);
  const isFixedOnPage          = getIsFixed(start);

  return {
    closestScrollable,
    isFixedOnPage,
  };
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/view/use-droppable-publisher/get-env.js